<template>
  <div id="blade1">
    <div id="bladeContainer">
      <Hero :obj="stObj"></Hero>
      <div id="gradient"></div>
      <div 
        id="learnmore" 
        @click="learnMore" 
        @keypress="learnMore" 
        :aria-label="stObj.learnMore" 
        tabindex="1"
        class="vz-button-link"
        data-loc="Content:Button:Pushing games to the edge">{{ stObj.learnMore }}</div>
      <div 
        id="arrow" 
        @click="learnMore"
        class="vs-button-link"
        data-loc="Content:Button:Pushing games to the edge:Learn more">
        <svg id="arrowbg" width="42px" height="35px" viewBox="0 0 42 35" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <g transform="translate(-701.000000, -951.000000)" id="00-Video-Header" stroke="#FFFFFF" stroke-width="2">
              <g>
                <g id="BG-Image">
                    <g id="Learn-More" transform="translate(640.000000, 909.000000)">
                        <g id="Arrow" transform="translate(62.333333, 43.500000)">
                        <line x1="0.333333333" y1="0.333333333" x2="17.6666667" y2="17.6666667" id="Line"></line>
                        <line x1="17.6666667" y1="0.333333333" x2="35" y2="17.6666667" id="Line" transform="translate(26.333333, 9.000000) scale(-1, 1) translate(-26.333333, -9.000000) "></line>
                        </g>
                       </g>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        <svg id="arrowsm" width="29px" height="35px" viewBox="0 0 29 35" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <g transform="translate(-701.000000, -953.000000)" id="00-Video-Header" stroke="#FFFFFF" stroke-width="2">
              <g>
                <g id="BG-Image">
                    <g id="Learn-More" transform="translate(640.000000, 909.000000) scale(0.9)">
                        <g id="Arrow" transform="translate(62.333333, 43.500000)">
                        <line x1="0.333333333" y1="0.333333333" x2="17.6666667" y2="17.6666667" id="Line"></line>
                        <line x1="17.6666667" y1="0.333333333" x2="35" y2="17.6666667" id="Line" transform="translate(26.333333, 9.000000) scale(-1, 1) translate(-26.333333, -9.000000) "></line>
                        </g>
                       </g>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "../../2019-immersive-modular-experience/src/components/Hero";

export default {
  name: "Blade1",
  data: function() {
    return {
      animated: true,
      scrollTimout: null,
      startTime: null,
      distance: 0,
      startPosition: 0,
    };
  },
  components: {
    Hero
  },
  computed: {
    stObj() {
      return this.$store.state.blade1
    }
  },
  mounted() {
    this.$nextTick(function() {
    })
  },
  methods: {
    onScroll() {
    },
    learnMore() {
      this.startPosition = window.pageYOffset;
      this.distance = document.querySelector("#blade2").getBoundingClientRect().top;
      this.startTime = null;
      
      requestAnimationFrame(this.animation);
    },
    
    animation(currentTime) {
      if (this.startTime == null) {
        this.startTime = currentTime;
      }

      let timeElapsed = currentTime - this.startTime;
      var run = this.easeOutQuad(timeElapsed, this.startPosition, this.distance, 1500);

      window.scrollTo(0, run);
      if (timeElapsed < 1500) {
        requestAnimationFrame(this.animation);
      }
    },

    easeOutQuad(t, b, c, d) {
      t /= d;
      t--;
      return c*(t*t*t + 1) + b;
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade1.scss";

</style>